import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { getQuestionsUrl } from '../../utilities/urlHelper';
import { MODELS } from '../../utilities/CONSTANTS';

const ConvertGeneratedToQuestionModal = ({
    generatedQuestion, hasAnswer, closeModal, kaiDashboard = false,
}) => {
    let generatedQuestionId = generatedQuestion.id;
    let generatedQuestionTitle = generatedQuestion.text || '';

    let answerableType = '';
    if (generatedQuestion?.generated_answer?.answerable_type) {
        answerableType = generatedQuestion.generated_answer.answerable_type;
    } else if (generatedQuestion?.answerable_type) {
        answerableType = generatedQuestion.answerable_type;
    } else if (!generatedQuestion?.generated_answer && generatedQuestion.source === 'kai_slack') {
        answerableType = MODELS.SEARCH_QUERY; // Kai Slack Answers - Kai failed to generate an answer - Ask Your Team
    }

    if (generatedQuestion.query) {
        generatedQuestionId = generatedQuestion.id;
        generatedQuestionTitle = generatedQuestion.query;
    }

    const onClickModal = useCallback(({ target }) => {
        if (!target) return;
        const className = target.getAttribute('class');
        if (closeModal && className?.includes('react-modal open')) {
            closeModal();
        }
    }, [closeModal]);

    return createPortal(
        <div className="react-modal open" onClick={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    {hasAnswer ? 'Save as Question and Answer' : 'Ask Your Team'}
                </h2>
                <div className="mt2 flex">
                    <p>
                        {hasAnswer
                            ? (
                                <>
                                    {'Are you sure you want to save this generated question '}
                                    <b>{`"${generatedQuestionTitle}"`}</b>
                                    {' and its generated answer?'}
                                </>
                            ) : (
                                <>
                                    {'Are you sure you want to ask your team about '}
                                    <b>{`"${generatedQuestionTitle}"`}</b>
                                    ? This will create a new question in the Asked tab.
                                </>
                            )}
                    </p>
                </div>
                <br />
                <form action={getQuestionsUrl()} method="POST">
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <input name="generated_question_to_question" type="hidden" value="true" />
                    <input name="generated_question_id" type="hidden" value={generatedQuestionId} />
                    <input name="answerable_type" type="hidden" value={answerableType} />
                    <input name="kai_dashboard" type="hidden" value={kaiDashboard} />
                    <input name="title" type="hidden" value={generatedQuestionTitle} />
                    <div className="right-align">
                        <span className="react-modal-close btn-secondary mr1" onClick={closeModal}>Cancel</span>
                        <input type="submit" className="btn btn-primary" value={hasAnswer ? 'Save' : 'Ask'} />
                    </div>
                </form>
            </div>
        </div>,
        document.body,
    );
};

export default ConvertGeneratedToQuestionModal;
